import { useEffect, useState } from 'react';

const STYLES = [
  {
    id: 'datatables-bs4-css',
    href: 'https://cdn.jsdelivr.net/npm/datatables.net-bs4@1.13.8/css/dataTables.bootstrap4.min.css',
  },
];

const SCRIPTS = [
  {
    id: 'jquery-cdn',
    src: 'https://cdn.jsdelivr.net/npm/jquery@3.7.1/dist/jquery.min.js',
  },
  {
    id: 'datatables-js',
    src: 'https://cdn.jsdelivr.net/npm/datatables.net@1.13.8/js/jquery.dataTables.min.js',
  },
  {
    id: 'datatables-bs4-js',
    src: 'https://cdn.jsdelivr.net/npm/datatables.net-bs4@1.13.8/js/dataTables.bootstrap4.min.js',
  },
];

function loadStyle({ id, href }) {
  if (document.getElementById(id)) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = href;
    link.onload = () => resolve();
    link.onerror = reject;
    document.head.appendChild(link);
  });
}

function loadScript({ id, src }) {
  if (document.getElementById(id)) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = false;
    script.onload = () => resolve();
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

/**
 * Load jQuery + DataTables (Bootstrap 4) for dashboard tables.
 */
export function useDataTablesAssets() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        await Promise.all(STYLES.map(loadStyle));
        for (const script of SCRIPTS) {
          await loadScript(script);
        }
        if (!cancelled) setReady(true);
      } catch (err) {
        console.error('DataTables assets failed to load:', err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return ready;
}

export function getJQuery() {
  return typeof window !== 'undefined' ? window.jQuery || window.$ : null;
}
